import { gql } from "@apollo/client";

const GET_CLASSES_FOR_DISCOVER = gql`
  query{
    discover{
      edges {
        _id
        class_name
        class_code
        class_description
        class_industry
        created_by{
          _id
          full_name
          avatar
        }
        lessons{
          _id
          lesson_name
        }
        no_of_students
      }
    }
  }
`;


export { GET_CLASSES_FOR_DISCOVER };